import axios from 'axios';
import { SERVER_URL } from "../const";
import Qs from 'qs';


export const getBondReportDataService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch IGST data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/get-bond-report-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data; // Return the data from the response
  } catch (error) {
    throw new Error('Error fetching IGST data:', error);
  }
};


export const getAdvAuthLedgerDataService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch Rodtep data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/get-adv-auth-ledger-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data; // Return the data from the response
  } catch (error) {
    console.error('Error:', error.message);
  }
};

export const getAdvAuthRdnLicReportService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch Adv Auth RDN Lic data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/reports/adv-rdn-lic-report`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data; // Return the data from the response
  } catch (error) {
    console.error('Error:', error.message);
  }
};